import React from 'react';
import './index.css'

export default class DataExplorerSources extends React.Component {
  render() {
    return (
      <div>

        <h2 className="f2 lh-title text-orange">Data sources</h2>
        <div  className="fl w-third pa1">

          <p>[WEF] Executive Opinion Survey</p>
          <p>[OECD] Trade Facilitation Indicators</p>
          <p>[WBTS] Logistics Performance Index</p>
          <p>[START] Global Terrorism Database</p>
          <p>[ITC] Market Access Map Database</p>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DataExplorerSources/index.js